import PropTypes from 'prop-types';
import React from 'react';

import { t } from '../../../../modules/infra/i18n';
import Money from '../../../common/money';

const MembershipsStats = ({ stats }) => (
  <div className="c-membership-stats-container u-mt+">
    <div className="c-memberships-container">
      <div className="c-memberships-container__text_small">{t('memberships:stats.total_members')}</div>
      <div className="c-memberships-container__title">{stats && stats.total}</div>
    </div>
    <div className="c-memberships-container">
      <div className="c-memberships-container__text_small">{t('memberships:stats.active_members')}</div>
      <div className="c-memberships-container__title">{stats && stats.active}</div>
    </div>
    <div className="c-memberships-container">
      <div className="c-memberships-container__text_small">{t('memberships:stats.paused_members')}</div>
      <div className="c-memberships-container__title">{stats && stats.paused}</div>
    </div>
    <div className="c-memberships-container">
      <div className="c-memberships-container__text_small">{t('memberships:stats.recurring_revenue')}</div>
      <div className="c-memberships-container__title">
        <Money display-if={stats}>{stats.projectedMonthlyRevenue}</Money>
      </div>
    </div>
  </div>
);

MembershipsStats.propTypes = {
  stats: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.oneOf([null]).isRequired]).isRequired,
};

export default MembershipsStats;
